import { Column, Row } from 'app/design/primitives/box';
import { Checkbox } from 'app/design/primitives/checkbox';
import { Text } from 'app/design/primitives/text';

import { useScopedTranslation } from 'app/hooks/i18n';
import { SharerType } from 'app/types/preferences';
import React from 'react';
import { Pressable, View } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const ChooseSharerTypeButton = ({
  sharerType,
  selectedSharerType,
  onSelect,
  disabled,
}: {
  sharerType: SharerType;
  selectedSharerType: SharerType | null;
  onSelect: (type: SharerType) => void;
  disabled: boolean;
}) => {
  const { t } = useScopedTranslation();

  const getBorderColor = (type: SharerType) =>
    selectedSharerType === type ? theme.colors['text.brand'] : theme.colors['border.secondary'];

  return (
    <Pressable
      accessibilityRole="radio"
      accessibilityState={{ checked: selectedSharerType === sharerType, disabled }}
      disabled={disabled}
      onPress={() => onSelect(sharerType)}
      style={{ opacity: disabled ? 0.6 : 1 }}
      testID={`sharer-type-${sharerType}`}
    >
      <Row
        gap="spacing.general.x4"
        style={{
          alignItems: 'center',
          borderColor: getBorderColor(sharerType),
          borderRadius: 12,
          borderWidth: 2,
          padding: theme.spacing['spacing.general.x4'],
        }}
      >
        <Text fontSize={24}>{t(`${sharerType}Emoji`)}</Text>
        <Text fontSize={16} fontWeight="700">
          {t(sharerType)}
        </Text>
        {selectedSharerType === sharerType ? (
          <View style={{ marginLeft: 'auto' }}>
            <Checkbox borderRadius="radius.xl" checked />
          </View>
        ) : null}
      </Row>
    </Pressable>
  );
};

export const ChooseSharerTypeOptions = ({
  gap,
  onSelect,
  selectedSharerType,
  disabled = false,
}: {
  gap: 'spacing.general.x4' | 'spacing.general.x5';
  onSelect: (type: SharerType) => void;
  selectedSharerType: SharerType | null;
  disabled?: boolean;
}) => {
  const { t } = useScopedTranslation();

  return (
    <Column gap={gap}>
      <Text marginBottom="spacing.general.x4" fontSize={18} textAlign="center">
        {t('subtitle', { appName: t('appName', { ns: 'common' }) })}
      </Text>

      {Object.values(SharerType).map((type) => (
        <ChooseSharerTypeButton
          disabled={disabled}
          key={type}
          selectedSharerType={selectedSharerType}
          sharerType={type}
          onSelect={onSelect}
        />
      ))}
    </Column>
  );
};
